export default __webpack_public_path__ + "static/media/gsm_0.dc16390c.svg";